<template>
    <Spinner v-if="userStore.isLoading"></Spinner>
    <div id="bst-wrap">
        <div class="l-project-wrap l-project-wrap--login">

            <section class="l-content-area">
                <div class="l-content">


                    <section class="p-bloc p-bloc--register">
                        <div class="p-bloc__content l-wrap__outer">
                            <div class="l-wrap__inner">

                                <div class="login-box">

                                    <div class="p-login__title">
                                        <div class="logo"><img src="@/assets/img/login/logo.png" alt="hubsynch"></div>
                                        <h1>{{ $t('LABEL_REGISTER_ACCOUNT') }}</h1>
                                    </div>

                                    <!-- verify -->
                                    <section class="p-verify c-register-parts">
                                        <p v-html="$t('TEXT_REGISTER_VERIFY_1')"></p>

                                        <form ref="inputRef">
                                            <div class="p-verify__form">

                                                <div class="mailaddress">
                                                    <div class="input-area" :class="{ 'is-error': v$.email.$error || userStore.registerVerifyErrors.email || userStore.registerVerifyErrorMsg }">
                                                        <!-- TODO: When there is an error, add "is-error" class to this "div.input-area" -->
                                                        <input type="email" name="email" id="email"
                                                            v-model="userStore.registerVerifyParams.email"
                                                            class="plchldr" :placeholder="$t('LABEL_EMAIL')" value="" required>
                                                    </div>

                                                    <p class="error-txt" v-if="v$.email.$error">{{ $t(v$.email.$errors[0].$message) }}</p>
                                                    <p class="error-txt" v-if="userStore.registerVerifyErrors.email">{{ userStore.registerVerifyErrors.email }}</p>
                                                </div>
                                                <div class="password">
                                                    <div class="password-area" :class="{ 'is-error': v$.password.$error || userStore.registerVerifyErrors.password || userStore.registerVerifyErrorMsg }">
                                                        <!-- TODO: When there is an error, add "is-error" class to this "div.password-area" -->
                                                        <input type="password" name="password" id="password"
                                                            v-model="userStore.registerVerifyParams.password"
                                                            class="plchldr" :placeholder="$t('LABEL_PASSWORD')" value="" required>
                                                        <div class="eye-btn"><a class="" href="#" aria-label="eye"></a>
                                                        </div>
                                                    </div>
                                                    <p class="sub-txt">{{ $t('TEXT_PASSWORD_VALIDATION') }}</p>
                                                    <p class="error-txt" v-if="v$.password.$error">{{ $t(v$.password.$errors[0].$message) }}</p>
                                                    <p class="error-txt" v-if="userStore.registerVerifyErrors.password">{{ userStore.registerVerifyErrors.password }}</p>
                                                </div>
                                                <div class="password-confirm">
                                                    <div class="password-area" :class="{ 'is-error': v$.password_confirmation.$error || userStore.registerVerifyErrors.password || userStore.registerVerifyErrorMsg }">
                                                        <!-- TODO: When there is an error, add "is-error" class to this "div.password-area" -->
                                                        <input type="password" name="password-confirm"
                                                            id="password-confirm"
                                                            v-model="userStore.registerVerifyParams.password_confirmation"
                                                            class="plchldr" :placeholder="$t('LABEL_PASSWORD_CONFIRM')" value="" required>
                                                        <div class="eye-btn"><a class="" href="#" aria-label="eye"></a>
                                                        </div>
                                                    </div>
                                                    <p class="error-txt" v-if="v$.password_confirmation.$error">{{ $t(v$.password_confirmation.$errors[0].$message) }}</p>
                                                    <p class="error-txt" v-if="userStore.registerVerifyErrorMsg">{{ userStore.registerVerifyErrorMsg }}</p>
                                                </div>

                                                <div class="c-btn c-btn--verify"><input type="button"
                                                        :value="$t('LABEL_REGISTER_EMAIL_BUTTON')" id="btn-register-verify"
                                                        @click="registerVerify()"></div>
                                            </div>
                                            <div class="p-verify__back">
                                                <div class="c-btn c-btn--tologin"><a id="link-login" href="/login">{{ $t('LABEL_BUTTON_TO_LOGIN_PAGE') }}</a></div>
                                            </div>
                                        </form>
                                    </section><!-- .p-verify -->

                                </div><!-- .bg-box -->


                            </div>
                        </div>
                    </section>


                </div><!-- .l-content -->
            </section><!-- .l-content-area -->

        </div><!-- .l-project-wrap -->

        <!-- footer -->

    </div>

</template>

<script setup>
import { useUserStore } from "@/stores/userStore";
import { useVuelidate } from "@vuelidate/core";
import { getRegisterVerifyRules } from "@/validations/userRegisterValidation";
import { ref, onMounted } from "vue";
import { initializeLogin } from "@/assets/js/entries/login";
import Spinner from "@/components/Spinner.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const userStore = useUserStore();
const inputRef = ref();

const v$ = useVuelidate(getRegisterVerifyRules(userStore, t), userStore.registerVerifyParams);

async function registerVerify() {
    if (!await v$.value.$validate()) {
        return false;
    }

    await userStore.registerVerify();
}

onMounted(() => {
    initializeLogin();
})
</script>